import { contentContainerStyle } from '@/components/ui/Layout/ContentContainer/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProListView のスタイル
 */
export const hotlineProListViewStyle = tv({
    slots: {
        content: [
            contentContainerStyle({ isMinWidthFull: true }),
            'mx-auto mb-32',
            'w-full max-w-[960px]',
        ],
        title: ['mb-32 px-0'],
        titleInner: [contentContainerStyle(), 'block', 'mx-auto'],
    },
});
